// Global flag to enable/disable Google Analytics
const GA_ENABLED = process.env.REACT_APP_GA_ENABLED !== 'false';

// Check if GA is available and enabled
const isGAReady = () => {
  return GA_ENABLED && typeof window !== 'undefined' && window.gtag;
};

// Google Analytics utility functions
export const trackPageView = (path) => {
  if (isGAReady()) {
    window.gtag('config', 'G-HB4RSBJ5NW', {
      page_path: path,
    });
  }
};

export const trackEvent = (action, category, label, value) => {
  if (isGAReady()) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track movie/show interactions
export const trackMovieView = (movieId, movieTitle) => {
  trackEvent('view_movie', 'Movies', movieTitle, movieId);
};

export const trackShowView = (showId, showTitle) => {
  trackEvent('view_show', 'Shows', showTitle, showId);
};

export const trackSearch = (searchTerm, resultCount) => {
  trackEvent('search', 'Search', searchTerm, resultCount);
};

export const trackOTTClick = (platform, contentTitle) => {
  trackEvent('ott_click', 'OTT', `${platform} - ${contentTitle}`);
};

// Track user interactions
export const trackUserAction = (action, details) => {
  trackEvent(action, 'User', details);
};

// Track feed interactions
export const trackFeedAction = (action, postId, details) => {
  trackEvent(action, 'Feed', `${details} - ${postId}`);
};

// Track profile interactions
export const trackProfileAction = (action, userId, details) => {
  trackEvent(action, 'Profile', `${details} - ${userId}`);
};

// Track chat interactions
export const trackChatAction = (action, details) => {
  trackEvent(action, 'Chat', details);
};

// Track watchlist actions
export const trackWatchlistAction = (action, contentType, contentId) => {
  trackEvent(action, 'Watchlist', `${contentType} - ${contentId}`);
};

// Track review actions
export const trackReviewAction = (action, contentType, contentId, rating) => {
  trackEvent(action, 'Reviews', `${contentType} - ${contentId}`, rating);
};

// Export GA status for debugging
export const getGAStatus = () => ({
  enabled: GA_ENABLED,
  ready: isGAReady(),
  gtag: typeof window !== 'undefined' && !!window.gtag,
  dataLayer: typeof window !== 'undefined' && !!window.dataLayer
});